import { trackInAdobe } from './service/adobe.js';

const trackEvent = (event) => {
    if (typeof window !== 'undefined') {
        trackInAdobe(event);
    }
};

export { trackEvent };
//# sourceMappingURL=index.js.map
